import React, { lazy, useEffect } from "react";
import { Navigate, useRoutes } from "react-router-dom";

//config
import { PATH_PAGE } from "../../config/path";

//Data Display
//import TopBar from '../../shared/data_display/TopBar/ui/TopBar';

//Pages
//import { Page404 } from "../../pages/Page404";


//navigation
//import { BottomTabMenu } from '../../shared/navigation/BottomTabMenu';
/*
//pages
import { HomePage } from "../../pages/home/ui/HomePage";
import { BuildingPage}  from "../../pages/building/ui/BuildingPage";
import { ContactPage } from "../../pages/contact/ui/ContactPage";
import { GalleryPage } from "../../pages/gallery/ui/GalleryPage";
import { NearmePage } from "../../pages/nearme/ui/NearmePage";
*/
// Lazy-loaded pages

const HomePage = lazy(() => import("../../pages/home").then((module)=>({default:module.HomePage})));
const BuildingPage = lazy(() => (import("../../pages/building").then((module)=>({default:module.BuildingPage}))));
const ContactPage = lazy(() => (import("../../pages/contact").then((module)=>({default:module.ContactPage}))));
const GalleryPage = lazy(() => (import("../../pages/gallery").then((module)=>({default:module.GalleryPage}))));
const NearmePage = lazy(() => (import("../../pages/nearme").then((module)=>({default:module.NearmePage}))));
/*-
const HomePage = lazy(() => import("../../pages/home"));
const BuildingPage = lazy(() => import("../../pages/building"));
const ContactPage = lazy(() => import("../../pages/contact"));
const GalleryPage = lazy(() => import("../../pages/gallery"));
const NearmePage = lazy(() => import("../../pages/nearme"));
*/


export function AppRouter({ onStartLoadingPage, onLoad } ) {

   const routes = useRoutes([
    {
      path: PATH_PAGE.root,
      element: (
            //<TopBar/>
            <HomePage onLoad={onLoad} onStartLoadingPage={()=>onStartLoadingPage?.()} />
        ),
    },
    {
        path: PATH_PAGE.home,
        element: (
            //<TopBar/>
            <HomePage onLoad={onLoad} onStartLoadingPage={()=>onStartLoadingPage?.()}/>                            
        )        
    },
    {
        path: PATH_PAGE.amenities,
        element: (
            //<TopBar/>
            <HomePage onLoad={onLoad} onStartLoadingPage={()=>onStartLoadingPage?.()}/>                            
        )        
    },    
    {
      path: PATH_PAGE.building,
      element: (
            //<TopBar/>
            <BuildingPage onLoad={onLoad} onStartLoadingPage={()=>onStartLoadingPage?.()}/>
        ),
    },
    {
      path: PATH_PAGE.contact,
      element: (
            //<TopBar/>
            <ContactPage onLoad={onLoad} />
        ),
    },
    {
      path: PATH_PAGE.gallery,
      element: (
            //<TopBar/>
            <GalleryPage />
        ),
    },
    {
      path: PATH_PAGE.nearme,
      element: (
            //<TopBar/>
            <NearmePage onLoad={onLoad}/>
        ),
    },
    {
      path: "*",
      children: [
        //{ path: "404", element: <Page404 /> },
        //{ path: "*", element: <Navigate replace to="/404" /> },
        { path: "*", element: <Navigate replace to={PATH_PAGE.home} /> },
      ],
    },
  ]);

  return routes;
}


// Agrega un retardo fijo para que puedas ver el estado de carga
function DelayForDemo(promise) {    
    //const [loaded, setLoaded] = useState(false);
/*
    let loaded = false;
    return new Promise(resolve => {
    <Suspense fallback={<div>Cargando...</div>}>
      <HomePage onLoad={() => loaded = true} />
      {loaded && <p>La página objetivo está completamente montada.</p>}
    </Suspense>
    }).then(() => promise);
  
  */
    return new Promise(resolve => {
      setTimeout(resolve, 1000);
    }).then(() => promise);
    
}
